import styled from 'styled-components';
import { Typ32 } from 'dc/Typ';
import Lab010 from 'dc/Lab010';
import Lab110 from 'dc/Lab110';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const TextWrapper = styled.div`
  min-width: 0;
  margin-left: 16px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const Name = styled(Typ32)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 22px;
  white-space: nowrap;
`;

export const Co2Label = styled(Lab110)`
  margin-left: 16px;

  > i {
    color: ${props => props.color || '#00ab97'};
  }
`;

export const TimeLabel = styled(Lab010)``;
